/* eslint-disable jsx-a11y/label-has-associated-control */
import SquareLoader from 'components/atoms/square_loader';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { passwordNew } from 'store/modules/profile_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';

const PasswordNew = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState<string>('');

  const { password_new } = useSelector<ApplicationState, ProfileState>(
    (state) => state.storage.profile,
  );

  return (
    <div className="row">
      <div className="col-md-12 text-center">
        <h4 className="font-weight-bold">Recuperar sua senha</h4>
        <div className="row  justify-content-center">
          <div className="col-md-4">
            <div className="card mt-3 p-5">
              <div className="card-body">
                <div className="text-left">
                  <label htmlFor="email"> Informe seu e-mail de acesso </label>
                  <input
                    type="text"
                    className="form-control mt-1"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    type="button"
                    className={`${
                      password_new?.loading
                        ? 'btn btn-secondary btn-lg btn-block my-3 disabled'
                        : 'btn btn-primary btn-lg btn-block my-3'
                    }`}
                    onClick={() => dispatch(passwordNew(email))}
                    disabled={email.length < 8}
                  >
                    {password_new?.loading ? (
                      <div className="d-inline-flex position-relative pr-4">
                        Enviando e-mail
                        <SquareLoader customClass="monitoring-message-loader" />
                      </div>
                    ) : (
                      <span>Enviar</span>
                    )}
                  </button>
                </div>
                <a href="/" className="mt-4">
                  Acessar sua conta
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordNew;
